import React from 'react';
import KycRequirements from './kyc-requirements';
export default function ProofOfEmployment() {
  return /*#__PURE__*/React.createElement(KycRequirements, {
    label: "Proof of Employment",
    icon: "Employee",
    list: ['Employment Status', 'Job Title', 'Job Position', 'Employee ID number', 'Date Hired', 'Monthly Salary']
  });
}
//# sourceMappingURL=proof-of-employment.js.map